<app-stepper-form
  header="Transfer"
  subheader="Form 484C3"
  [steps]="steps"
  [currentStep]="currentStep"
  [currentStepIndex]="currentStepIndex"
  [isLoading]="isLoading"
  [isInvalid]="hasShareIssue"
  [form]="stepperForm"
>
  <div class="step-content share-transfer full-width" [formGroup]="stepperForm">
    <div class="step-content">
      <app-stepper-form-description
        formKey="484C3"
        [hidden]="currentStep !== StepsEnum.FormDescription"
      />
    </div>

    <section
      class="step-section transfer-from"
      [formGroupName]="StepsEnum.TransferFrom"
      [hidden]="currentStep !== StepsEnum.TransferFrom"
    >
      <h1 class="h1-heading">Transferor (Seller)</h1>

      <div class="form-group">
        <app-date-picker
          label="Date of Transfer"
          formControlName="date"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [smallWidth]="true"
          [customErrors]="customDatepickerErrors"
        />
      </div>

      @if (lateFeeMessage) {
        <app-disclaimer
          color="red"
          icon="ic-info-circle-20"
        >
          {{ lateFeeMessage }}
        </app-disclaimer>
      }

      @if (shareTransferToBlock()) {
        <app-share-transfer-from-block
          [formGroup]="transferFromForm"
          [securityRegistryRecords]="securityRegistryRecords"
          [transferToBlock]="shareTransferToBlock()"
        />
      }
    </section>

    <section
      class="step-section transfer-to"
      [formGroupName]="StepsEnum.TransferTo"
      [hidden]="currentStep !== StepsEnum.TransferTo"
    >
      <h1 class="h1-heading">Transferee (Buyer)</h1>

      <app-share-transfer-to-block
        [formGroup]="transferToForm"
        [authorisedSecurityRegistryRecords]="authorisedSecurityRegistryRecords"
      />

      <div class="form-group share-numbers-grid big-left">
        <app-select
          label="Certificate Consolidation"
          formControlName="consolidateCertificate"
          [options]="certificateConsolidationOptions"
          [valuePrimitive]="true"
        />

        <input-certificate-number
          label="Certificate Number"
          formControlName="shareCertificateNumber"
          [entityId]="companyChangeData.entityId"
          [transactionsList]="transactionsList"
        />
      </div>
    </section>

    <section
      class="step-section"
      [formGroupName]="StepsEnum.AuthorisedSignatories"
      [hidden]="currentStep !== StepsEnum.AuthorisedSignatories"
    >
      <app-authorised-signatories-step
        title="Authorised Signatories"
        [formGroup]="authorisedSignatoriesForm"
        [securityRegistryRecords]="authorisedSecurityRegistryRecords"
      />
    </section>

    <section
      class="step-section estimate w-100"
      [formGroupName]="StepsEnum.Estimate"
      [hidden]="currentStep !== StepsEnum.Estimate"
    >
      <h1 class="h1-heading">Estimate</h1>

      <app-share-estimate-table
        [isEstimateLoading]="isEstimateLoading"
        [estimatedSecurityRegistryRecords]="estimatedSecurityRegistryRecords"
      />
    </section>
  </div>
</app-stepper-form>
